var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMailSent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 520,
    height: 387.462,
    viewBox: "0 0 520 387.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mail_sent-rafiki",
    "data-name": "Mail sent-rafiki",
    transform: "translate(0 -55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-24",
    transform: "translate(0 55)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18620",
    "data-name": "Rectangle 18620",
    width: 520,
    height: 0.26,
    transform: "translate(0 340.496)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18621",
    "data-name": "Rectangle 18621",
    width: 35.776,
    height: 0.26,
    transform: "translate(356.99 351.51)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18622",
    "data-name": "Rectangle 18622",
    width: 20.134,
    height: 0.26,
    transform: "translate(95.347 351.634)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18623",
    "data-name": "Rectangle 18623",
    width: 40.81,
    height: 0.26,
    transform: "translate(220.23 351.031)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18624",
    "data-name": "Rectangle 18624",
    width: 18.242,
    height: 0.26,
    transform: "translate(200.949 347.329)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18625",
    "data-name": "Rectangle 18625",
    width: 55.11,
    height: 0.26,
    transform: "translate(386.433 347.464)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39216",
    "data-name": "Path 39216",
    d: "M244.952,349.112H44.138a5.938,5.938,0,0,1-5.928-5.938V60.886A5.938,5.938,0,0,1,44.138,55H244.952a5.938,5.938,0,0,1,5.938,5.938V343.174A5.938,5.938,0,0,1,244.952,349.112ZM44.138,55.208a5.678,5.678,0,0,0-5.668,5.678V343.174a5.678,5.678,0,0,0,5.668,5.678H244.952a5.689,5.689,0,0,0,5.678-5.678V60.886a5.689,5.689,0,0,0-5.678-5.678Z",
    transform: "translate(1.528 -55)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39217",
    "data-name": "Path 39217",
    d: "M461.262,349.112H260.438a5.949,5.949,0,0,1-5.938-5.938V60.886A5.949,5.949,0,0,1,260.438,55H461.262a5.938,5.938,0,0,1,5.918,5.886V343.174A5.938,5.938,0,0,1,461.262,349.112ZM260.438,55.208a5.689,5.689,0,0,0-5.678,5.678V343.174a5.689,5.689,0,0,0,5.678,5.678H461.262a5.689,5.689,0,0,0,5.678-5.678V60.886a5.689,5.689,0,0,0-5.678-5.678Z",
    transform: "translate(10.18 -55)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39218",
    "data-name": "Path 39218",
    d: "M442.938,262.943c-12.792-19.479-1.113-40.414-3.058-62.088s-22.537-26.4-18.637-44.72c4.514-21.3-7.519-41.735-21.154-41.735s-25.657,20.384-21.143,41.7c3.9,18.356-16.64,23.088-18.637,44.72s9.734,42.64-3.068,62.088-9.433,45.271-2.226,58.074A49.636,49.636,0,0,0,361.9,330.4a52.2,52.2,0,0,0,76.388,0,50.055,50.055,0,0,0,6.874-9.412C452.381,308.214,455.74,282.464,442.938,262.943Z",
    transform: "translate(13.945 -52.624)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39219",
    "data-name": "Path 39219",
    d: "M398.359,271.44h0a6.469,6.469,0,0,1,6.469,6.469v108.93H391.89V277.909a6.469,6.469,0,0,1,6.469-6.469Z",
    transform: "translate(15.676 -46.342)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39220",
    "data-name": "Path 39220",
    d: "M320.586,386.928H303V278.009a8.83,8.83,0,0,1,8.809-8.809h0a8.83,8.83,0,0,1,8.809,8.809Z",
    transform: "translate(12.12 -46.432)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3094",
    "data-name": "Ellipse 3094",
    cx: 54.257,
    cy: 54.257,
    r: 54.257,
    transform: "translate(269.641 202.602)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3095",
    "data-name": "Ellipse 3095",
    cx: 21.382,
    cy: 21.382,
    r: 21.382,
    transform: "translate(340.998 251.021) rotate(-76.05)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3096",
    "data-name": "Ellipse 3096",
    cx: 12.657,
    cy: 12.657,
    r: 12.657,
    transform: "translate(265.483 233.217) rotate(-80.75)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3097",
    "data-name": "Ellipse 3097",
    cx: 8.882,
    cy: 8.882,
    r: 8.882,
    transform: "translate(284.898 207.334)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39221",
    "data-name": "Path 39221",
    d: "M209.5,321.08a58.812,58.812,0,0,0-23.629,9.017c-.062-8.237-1.57-16.047-5.439-22.36-5.886,5.73-10.66,13.156-14.56,21.143-1.425-14.966-5.366-29.526-14.092-38.75-13.073,8.226-19.812,21.934-23.015,36.452a66.009,66.009,0,0,0-22.329-24.107c-8,8.424-10.556,20.072-10.338,32.011-9.09-10.587-19.178-18.845-29.016-19.812-2.423,16.734,2.735,32.521,9.3,45A49.837,49.837,0,0,0,120.55,386.1h42.734c18.21,0,35.287-9.714,43.826-25.8C212.507,350.107,215.086,336.992,209.5,321.08Z",
    transform: "translate(2.659 -45.595)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39222",
    "data-name": "Path 39222",
    d: "M197.491,113.158c5.273-15.465,1.04-26.478-11.825-26.478-8.091,0-18.127,4.337-27.9,11.388-1.1-4.025-4.212-6.427-9.214-6.427-8.809,0-20.946,7.446-30.462,17.95a14.56,14.56,0,0,0-9.922-4c-8.434-.478-18.637,3.806-27.508,10.764a4.794,4.794,0,0,0-3.91-2.007c-4.857-.27-11.44,4.056-14.7,9.651-.2.343-.374.686-.562,1.04H200.049C200.465,120.147,199.6,116.07,197.491,113.158Z",
    transform: "translate(2.46 -53.733)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39223",
    "data-name": "Path 39223",
    d: "M195.224,202.927c2.579-7.55.53-12.927-5.772-12.927-3.962,0-8.861,2.08-13.634,5.564a4.222,4.222,0,0,0-4.5-3.12c-4.3,0-10.223,3.64-14.882,8.778a7.062,7.062,0,0,0-4.846-1.955c-4.16-.239-9.1,1.851-13.437,5.252a2.34,2.34,0,0,0-1.862-1c-2.371-.135-5.585,1.976-7.176,4.711l-.281.5h67.683a8.5,8.5,0,0,0-1.29-5.8Z",
    transform: "translate(5.153 -49.6)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39224",
    "data-name": "Path 39224",
    d: "M349.854,148.639a11.764,11.764,0,0,0-1.612-.114c.5-7.54-2.382-12.366-8.549-12.366-4.441,0-9.9,2.517-15.454,6.77,1.591-14.643-3.5-24.159-15.049-24.159-9.3,0-21.081,6.24-32.718,16.286-1.04-5.741-4.451-9.194-10.213-9.194-10.119,0-24.5,10.65-36.036,25.667h0a14.56,14.56,0,0,0-11.17-5.751c-9.63-.676-21.6,5.439-32.24,15.4a4.919,4.919,0,0,0-4.378-2.86c-5.273-.374-12.48,5.127-16.754,12.48H358.33C362.854,159.652,359.255,149.9,349.854,148.639Z",
    transform: "translate(6.627 -52.449)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-24",
    transform: "translate(58.354 418.917)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3098",
    "data-name": "Ellipse 3098",
    cx: 201.646,
    cy: 11.773,
    rx: 201.646,
    ry: 11.773,
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mail--inject-24",
    transform: "translate(50.814 95.491)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39225",
    "data-name": "Path 39225",
    d: "M48.86,150.56l237.089,34.133,31.814,32.1Z",
    transform: "translate(-48.86 -91.668)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39226",
    "data-name": "Path 39226",
    d: "M48.86,150.56l237.089,34.133,31.814,32.1Z",
    transform: "translate(-48.86 -91.668)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39227",
    "data-name": "Path 39227",
    d: "M48.86,150.56l237.089,34.133-11,46.426Z",
    transform: "translate(-48.86 -91.668)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39228",
    "data-name": "Path 39228",
    d: "M48.86,150.56l237.089,34.133-11,46.426Z",
    transform: "translate(-48.86 -91.668)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39229",
    "data-name": "Path 39229",
    d: "M266.787,99.077l13.759,64.48a6.5,6.5,0,0,1-4.992,7.706l-122.8,26.208a6.51,6.51,0,0,1-7.706-4.992L131.275,128a6.51,6.51,0,0,1,5-7.706l122.8-26.208a6.51,6.51,0,0,1,7.706,5Z",
    transform: "translate(-45.569 -93.933)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39230",
    "data-name": "Path 39230",
    d: "M266.787,99.077l13.759,64.48a6.5,6.5,0,0,1-4.992,7.706l-122.8,26.208a6.51,6.51,0,0,1-7.706-4.992L131.275,128a6.51,6.51,0,0,1,5-7.706l122.8-26.208a6.51,6.51,0,0,1,7.706,5Z",
    transform: "translate(-45.569 -93.933)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39231",
    "data-name": "Path 39231",
    d: "M263.716,94.855l-41.028,50.367a26.447,26.447,0,0,1-32.4,6.916L132.27,122.915a6.469,6.469,0,0,1,3.962-2.631l122.8-26.208a6.479,6.479,0,0,1,4.68.78Z",
    transform: "translate(-45.524 -93.933)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39232",
    "data-name": "Path 39232",
    d: "M48.86,150.56l195.551,46.478,30.534,34.081Z",
    transform: "translate(-48.86 -91.668)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39233",
    "data-name": "Path 39233",
    d: "M48.86,150.56l195.551,46.478,30.534,34.081Z",
    transform: "translate(-48.86 -91.668)",
    fill: "#fff",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18626",
    "data-name": "Rectangle 18626",
    width: 1.04,
    height: 25.22,
    transform: "matrix(0.505, -0.863, 0.863, 0.505, 70.807, 104.586)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18627",
    "data-name": "Rectangle 18627",
    width: 1.04,
    height: 9.069,
    transform: "matrix(0.505, -0.863, 0.863, 0.505, 102.177, 122.953)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39234",
    "data-name": "Path 39234",
    d: "M48.86,150.56l195.551,46.478L206.4,242.85Z",
    transform: "translate(-48.86 -91.668)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39235",
    "data-name": "Path 39235",
    d: "M301.665,255.9a2.08,2.08,0,0,1-.77-.146l-31.845-12.6a2.08,2.08,0,1,1,1.529-3.869l31.855,12.6a2.08,2.08,0,0,1-.77,4.014Z",
    transform: "translate(-40.105 -88.125)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39236",
    "data-name": "Path 39236",
    d: "M301.665,255.9a2.08,2.08,0,0,1-.77-.146l-31.845-12.6a2.08,2.08,0,1,1,1.529-3.869l31.855,12.6a2.08,2.08,0,0,1-.77,4.014Z",
    transform: "translate(-40.105 -88.125)",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39237",
    "data-name": "Path 39237",
    d: "M299.288,238.122a1.986,1.986,0,0,1-.759-.156l-17.108-6.812a2.08,2.08,0,1,1,1.529-3.869l17.108,6.781a2.106,2.106,0,0,1-.77,4.056Z",
    transform: "translate(-39.61 -88.605)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39238",
    "data-name": "Path 39238",
    d: "M299.288,238.122a1.986,1.986,0,0,1-.759-.156l-17.108-6.812a2.08,2.08,0,1,1,1.529-3.869l17.108,6.781a2.106,2.106,0,0,1-.77,4.056Z",
    transform: "translate(-39.61 -88.605)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39239",
    "data-name": "Path 39239",
    d: "M265.435,255.634a2.183,2.183,0,0,1-.759-.146l-31.065-12.334a2.08,2.08,0,1,1,1.529-3.869L266.2,251.578a2.08,2.08,0,0,1-.77,4.014Z",
    transform: "translate(-41.523 -88.125)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39240",
    "data-name": "Path 39240",
    d: "M265.435,255.634a2.183,2.183,0,0,1-.759-.146l-31.065-12.334a2.08,2.08,0,1,1,1.529-3.869L266.2,251.578a2.08,2.08,0,0,1-.77,4.014Z",
    transform: "translate(-41.523 -88.125)",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-24",
    transform: "translate(271.097 111.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39241",
    "data-name": "Path 39241",
    d: "M372.7,164.82c2.756,5.377,5.283,10.764,7.686,16.276s4.638,11.1,6.594,16.952l.707,2.215c.125.4.3,1.04.406,1.5s.2.978.25,1.414a36.726,36.726,0,0,1,.364,5.065,90.777,90.777,0,0,1-.437,9.36,149.922,149.922,0,0,1-2.829,17.909l-5.71-.634c-.073-5.855-.125-11.773-.333-17.545-.094-2.87-.26-5.751-.551-8.455a31.744,31.744,0,0,0-.624-3.775c-.052-.291-.135-.51-.2-.749s-.125-.322-.229-.634L377,201.75c-2.174-5.262-4.618-10.566-7.114-15.85l-7.55-15.85Z",
    transform: "translate(-256.603 -107.256)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39242",
    "data-name": "Path 39242",
    d: "M379.242,230.42,376.58,235.4l8.507,2.371s1.622-4-.312-7.166Z",
    transform: "translate(-256.034 -104.632)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39243",
    "data-name": "Path 39243",
    d: "M373.45,242.386l7.821.624,3.942-5.429-8.507-2.371Z",
    transform: "translate(-256.159 -104.44)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39244",
    "data-name": "Path 39244",
    d: "M337.926,130.308c-.114.614-.541,1.04-.936.957s-.614-.634-.489-1.238.541-1.04.936-.957S338.061,129.7,337.926,130.308Z",
    transform: "translate(-257.638 -108.686)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39245",
    "data-name": "Path 39245",
    d: "M337.562,131.26a22.2,22.2,0,0,1-3.942,4.586,3.578,3.578,0,0,0,2.777,1.123Z",
    transform: "translate(-257.752 -108.598)",
    fill: "#de5753"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39246",
    "data-name": "Path 39246",
    d: "M340.767,127.54a.374.374,0,0,1-.26-.114,2.891,2.891,0,0,0-2.423-.978.364.364,0,0,1-.125-.707,3.536,3.536,0,0,1,3.12,1.2.364.364,0,0,1,0,.51.374.374,0,0,1-.312.094Z",
    transform: "translate(-257.588 -108.82)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39247",
    "data-name": "Path 39247",
    d: "M355.072,138.43c-1.092,5.6-2.184,15.829,1.726,19.562,0,0-1.529,5.668-11.918,5.668-11.44,0-5.45-5.668-5.45-5.668,6.24-1.487,6.063-6.115,4.982-10.452Z",
    transform: "translate(-257.582 -108.312)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39248",
    "data-name": "Path 39248",
    d: "M358.363,160.943c.822-2.735,1.726-5.866-.146-6.854-2.08-1.04-13.385-2.184-17.285-.156s-2.787,7.592-2.787,7.592Z",
    transform: "translate(-257.577 -107.736)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39249",
    "data-name": "Path 39249",
    d: "M380.716,410.07a2.444,2.444,0,0,1-1.83-.5.738.738,0,0,1,0-.863.863.863,0,0,1,.572-.426c1.123-.25,3.224,1.186,3.318,1.248a.208.208,0,0,1,.073.187.166.166,0,0,1-.135.135,9.717,9.717,0,0,1-2,.218Zm-.957-1.456h-.218a.489.489,0,0,0-.333.25c-.166.291-.062.416,0,.458.322.437,1.882.437,3.026.25a6.012,6.012,0,0,0-2.475-.936Z",
    transform: "translate(-255.947 -97.519)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39250",
    "data-name": "Path 39250",
    d: "M382.607,409.952h-.083c-.79-.437-2.319-2.08-2.163-2.954a.593.593,0,0,1,.582-.478,1.04,1.04,0,0,1,.77.229c.884.728,1.04,2.933,1.04,3.026a.166.166,0,0,1-.083.166A.145.145,0,0,1,382.607,409.952Zm-1.539-3.12h-.042c-.239,0-.26.146-.27.187-.094.51.884,1.768,1.664,2.361a4.357,4.357,0,0,0-.894-2.392.666.666,0,0,0-.5-.135Z",
    transform: "translate(-255.883 -97.588)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39251",
    "data-name": "Path 39251",
    d: "M336.621,410.071c-.978,0-1.924-.135-2.246-.572a.686.686,0,0,1,0-.79.915.915,0,0,1,.582-.426c1.258-.343,3.942,1.175,4.056,1.238a.187.187,0,0,1,.083.187.177.177,0,0,1-.146.146,12.655,12.655,0,0,1-2.33.218Zm-1.217-1.477a1.2,1.2,0,0,0-.343,0,.531.531,0,0,0-.354.25c-.135.229-.083.333,0,.4.343.478,2.278.51,3.713.312a8.185,8.185,0,0,0-3.016-.936Z",
    transform: "translate(-257.727 -97.519)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39252",
    "data-name": "Path 39252",
    d: "M338.853,409.953h-.073c-.926-.406-2.746-2.08-2.61-2.922,0-.208.177-.458.676-.51a1.269,1.269,0,0,1,1.04.312c.978.79,1.175,2.85,1.186,2.943a.159.159,0,0,1-.218.177Zm-1.862-3.12h-.114c-.322,0-.343.166-.354.208-.083.52,1.165,1.82,2.08,2.382a4.16,4.16,0,0,0-1.04-2.35.9.9,0,0,0-.53-.218Z",
    transform: "translate(-257.65 -97.588)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39253",
    "data-name": "Path 39253",
    d: "M347.153,410.32h-7.644l-.759-17.69h7.644Z",
    transform: "translate(-257.547 -98.144)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39254",
    "data-name": "Path 39254",
    d: "M391.382,410.32h-7.644L379.9,392.63h7.634Z",
    transform: "translate(-255.901 -98.144)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39255",
    "data-name": "Path 39255",
    d: "M383.529,408.79h8.58a.676.676,0,0,1,.655.53l1.508,6.791a1.123,1.123,0,0,1-1.123,1.352c-3-.052-4.451-.229-8.226-.229-2.319,0-7.1.25-10.317.25s-3.619-3.12-2.309-3.463c5.886-1.29,8.1-3.068,9.984-4.753A1.851,1.851,0,0,1,383.529,408.79Z",
    transform: "translate(-256.233 -97.497)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39256",
    "data-name": "Path 39256",
    d: "M340.241,408.79h8.32a.676.676,0,0,1,.655.53l1.508,6.791a1.113,1.113,0,0,1-1.1,1.352c-3.006-.052-7.353-.229-11.138-.229-4.42,0-8.247.25-13.437.25-3.12,0-4-3.12-2.694-3.463,5.98-1.31,10.858-1.446,16.026-4.628a3.494,3.494,0,0,1,1.862-.6Z",
    transform: "translate(-258.226 -97.497)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39257",
    "data-name": "Path 39257",
    d: "M338.6,171.578a175.941,175.941,0,0,1-19.042-2.527c-3.12-.6-6.3-1.279-9.464-2.132a76.055,76.055,0,0,1-9.526-3.12c-.8-.333-1.612-.7-2.413-1.04a21.288,21.288,0,0,1-2.6-1.518c-1.5-.988-2.787-2.018-4.066-3.037-2.548-2.08-4.909-4.16-7.28-6.292-4.649-4.306-9.058-8.757-13.312-13.437l3.827-4.274,15.09,10.847c2.486,1.789,5,3.546,7.478,5.2,1.227.822,2.486,1.591,3.64,2.246a12.643,12.643,0,0,0,1.5.728c.614.239,1.238.478,1.893.707a112.319,112.319,0,0,0,17.191,3.848c5.938.936,12.074,1.706,18,2.33Z",
    transform: "translate(-260.261 -108.481)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39258",
    "data-name": "Path 39258",
    d: "M369.6,158.909c7.166,1.643,14.4,22.578,14.4,22.578l-14.737,10.577s-4.16-9.755-8.174-18.283C356.9,164.847,362.282,157.235,369.6,158.909Z",
    transform: "translate(-256.712 -107.502)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39259",
    "data-name": "Path 39259",
    d: "M369.6,158.909c7.166,1.643,14.4,22.578,14.4,22.578l-14.737,10.577s-4.16-9.755-8.174-18.283C356.9,164.847,362.282,157.235,369.6,158.909Z",
    transform: "translate(-256.712 -107.502)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39260",
    "data-name": "Path 39260",
    d: "M365.362,169.9l-2.922,6.542c3.026,6.531,5.793,13,6.531,14.726C368.867,183.441,367.4,173.852,365.362,169.9Z",
    transform: "translate(-256.599 -107.053)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39261",
    "data-name": "Path 39261",
    d: "M365.362,169.9l-2.922,6.542c3.026,6.531,5.793,13,6.531,14.726C368.867,183.441,367.4,173.852,365.362,169.9Z",
    transform: "translate(-256.599 -107.053)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39262",
    "data-name": "Path 39262",
    d: "M328.214,159.371s-8.133,9.183-.458,66.04h40.862c.291-6.24-3.65-36.878,2.392-66.435a106.66,106.66,0,0,0-13.676-1.726,151.079,151.079,0,0,0-17.368,0,76.441,76.441,0,0,0-11.752,2.122Z",
    transform: "translate(-258.118 -107.569)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39263",
    "data-name": "Path 39263",
    d: "M328.214,159.371s-8.133,9.183-.458,66.04h40.862c.291-6.24-3.65-36.878,2.392-66.435a106.66,106.66,0,0,0-13.676-1.726,151.079,151.079,0,0,0-17.368,0,76.441,76.441,0,0,0-11.752,2.122Z",
    transform: "translate(-258.118 -107.569)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39264",
    "data-name": "Path 39264",
    d: "M325.184,169.9c-.27,2.153-.478,4.7-.614,7.706a42.722,42.722,0,0,0,11.378-5.346Z",
    transform: "translate(-258.114 -107.053)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39265",
    "data-name": "Path 39265",
    d: "M325.184,169.9c-.27,2.153-.478,4.7-.614,7.706a42.722,42.722,0,0,0,11.378-5.346Z",
    transform: "translate(-258.114 -107.053)",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39266",
    "data-name": "Path 39266",
    d: "M343.04,171.61c-5.47,4.846-26.354,4.358-26.354,4.358L316,155.75a154.1,154.1,0,0,0,21.289,1.539C348.926,157.05,349.01,166.264,343.04,171.61Z",
    transform: "translate(-258.457 -107.619)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39267",
    "data-name": "Path 39267",
    d: "M343.04,171.61c-5.47,4.846-26.354,4.358-26.354,4.358L316,155.75a154.1,154.1,0,0,0,21.289,1.539C348.926,157.05,349.01,166.264,343.04,171.61Z",
    transform: "translate(-258.457 -107.619)",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39268",
    "data-name": "Path 39268",
    d: "M275.186,134.476l-5.2-6.126-5.606,6.24s3.453,5.8,8.934,4.888Z",
    transform: "translate(-260.522 -108.715)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39269",
    "data-name": "Path 39269",
    d: "M262.688,121.48l-2.018,8,3.817,5.346,5.606-6.2Z",
    transform: "translate(-260.67 -108.99)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39270",
    "data-name": "Path 39270",
    d: "M338.75,392.64l.4,9.11h7.644l-.4-9.11Z",
    transform: "translate(-257.547 -98.143)",
    fill: "#ce6f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39271",
    "data-name": "Path 39271",
    d: "M387.544,392.64H379.9l1.976,9.11h7.644Z",
    transform: "translate(-255.901 -98.143)",
    fill: "#ce6f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39272",
    "data-name": "Path 39272",
    d: "M343.358,123.541c-6.854-3.12-9.017-16.983,10.7-13.52,0,0-2.974,3.286,3.058,5.366S358.1,130.312,343.358,123.541Z",
    transform: "translate(-257.558 -109.47)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39273",
    "data-name": "Path 39273",
    d: "M358.368,133.505c-1.966,7.28-2.735,11.71-7.28,14.758-6.8,4.576-15.257-.676-15.527-8.445-.239-6.978,3.016-17.784,10.868-19.261a10.338,10.338,0,0,1,11.939,12.948Z",
    transform: "translate(-257.675 -109.034)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39274",
    "data-name": "Path 39274",
    d: "M353.545,113.544c4.67,2.6,10.993,4.16,10.4,7.862-.78,4.524,3.817,1.7,2.746,8.424-.7,4.4-8.809,17.732-14.56,17.087-8.59-1.04-7.5-14.1-7.53-20.987C344.58,121.864,344.393,108.417,353.545,113.544Z",
    transform: "translate(-257.314 -109.353)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39275",
    "data-name": "Path 39275",
    d: "M343.694,119.11c-2.08.489-4.836,12.48,3.224,13.582C356.185,133.951,343.694,119.11,343.694,119.11Z",
    transform: "translate(-257.437 -109.084)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39276",
    "data-name": "Path 39276",
    d: "M344.105,123.487c-2.548.229-8.32-2.839-7.613-7.457C336.492,116,340.143,121.428,344.105,123.487Z",
    transform: "translate(-257.639 -109.208)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39277",
    "data-name": "Path 39277",
    d: "M347.712,133.242a8.538,8.538,0,0,1-3.775,4c-2.194,1.144-3.432-.52-2.933-2.725.447-1.976,2.132-4.961,4.389-5.2S348.617,131.162,347.712,133.242Z",
    transform: "translate(-257.461 -108.677)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39278",
    "data-name": "Path 39278",
    d: "M358.45,125.293a10.244,10.244,0,0,0,6.011-7.623S367.893,127.207,358.45,125.293Z",
    transform: "translate(-256.759 -109.142)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39279",
    "data-name": "Path 39279",
    d: "M366.981,124.934a5.273,5.273,0,0,0-4.971-.489S365.213,120.3,366.981,124.934Z",
    transform: "translate(-256.616 -108.939)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39280",
    "data-name": "Path 39280",
    d: "M341.57,222.782s8.674,58.386,13.426,80.257c5.2,23.92,24.856,103.75,24.856,103.75H393.84s-12.948-77.865-15.922-101.618c-3.224-25.74-9.984-82.43-9.984-82.43Z",
    transform: "translate(-257.434 -104.939)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39281",
    "data-name": "Path 39281",
    d: "M341.57,222.782s8.674,58.386,13.426,80.257c5.2,23.92,24.856,103.75,24.856,103.75H393.84s-12.948-77.865-15.922-101.618c-3.224-25.74-9.984-82.43-9.984-82.43Z",
    transform: "translate(-257.434 -104.939)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39282",
    "data-name": "Path 39282",
    d: "M376.23,394.75c-.062,0,1.446,5.377,1.446,5.377h15.746l-.291-4.794Z",
    transform: "translate(-256.048 -98.059)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39283",
    "data-name": "Path 39283",
    d: "M376.23,394.75c-.062,0,1.446,5.377,1.446,5.377h15.746l-.291-4.794Z",
    transform: "translate(-256.048 -98.059)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39284",
    "data-name": "Path 39284",
    d: "M346.927,242.783c10.026,1.966,8.965,39.354,7.758,58.583-2.891-13.593-7.124-39.749-10.015-58.313a3.422,3.422,0,0,1,2.257-.27Z",
    transform: "translate(-257.31 -104.141)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39285",
    "data-name": "Path 39285",
    d: "M346.927,242.783c10.026,1.966,8.965,39.354,7.758,58.583-2.891-13.593-7.124-39.749-10.015-58.313a3.422,3.422,0,0,1,2.257-.27Z",
    transform: "translate(-257.31 -104.141)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39286",
    "data-name": "Path 39286",
    d: "M327.651,222.78s-1.04,57.117-.218,80.423c.863,24.232,9.36,103.584,9.36,103.584H349.73s.478-77.938,1.04-101.733c.634-25.948,3.765-82.274,3.765-82.274Z",
    transform: "translate(-258.012 -104.938)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39287",
    "data-name": "Path 39287",
    d: "M327.651,222.78s-1.04,57.117-.218,80.423c.863,24.232,9.36,103.584,9.36,103.584H349.73s.478-77.938,1.04-101.733c.634-25.948,3.765-82.274,3.765-82.274Z",
    transform: "translate(-258.012 -104.938)",
    fill: "#fff",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39288",
    "data-name": "Path 39288",
    d: "M339.337,397.326a.125.125,0,0,1-.125-.114c-2.288-21.965-7.665-75.109-8.32-94.172-.7-19.458-.062-63.118.146-76.034a.125.125,0,0,1,.125-.125h0a.135.135,0,0,1,.135.125c-.208,12.917-.842,56.576-.146,76.024.676,19.063,6.053,72.186,8.32,94.151a.146.146,0,0,1-.125.146Z",
    transform: "translate(-257.874 -104.774)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39289",
    "data-name": "Path 39289",
    d: "M339.337,397.326a.125.125,0,0,1-.125-.114c-2.288-21.965-7.665-75.109-8.32-94.172-.7-19.458-.062-63.118.146-76.034a.125.125,0,0,1,.125-.125h0a.135.135,0,0,1,.135.125c-.208,12.917-.842,56.576-.146,76.024.676,19.063,6.053,72.186,8.32,94.151a.146.146,0,0,1-.125.146Z",
    transform: "translate(-257.874 -104.774)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39290",
    "data-name": "Path 39290",
    d: "M334,394.75c-.052,0,.738,5.377.738,5.377h15.735l.426-4.794Z",
    transform: "translate(-257.737 -98.059)",
    fill: "#01a765"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39291",
    "data-name": "Path 39291",
    d: "M334,394.75c-.052,0,.738,5.377.738,5.377h15.735l.426-4.794Z",
    transform: "translate(-257.737 -98.059)",
    opacity: 0.1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSent);
export default __webpack_public_path__ + "static/media/MailSent.00ed33395ed3fe89d79fc650120f35b6.svg";
export { ForwardRef as ReactComponent };